import MutedSuggestionActionItem from './MutedSuggestionActionItem.component';

export default MutedSuggestionActionItem;